import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import Dropdown from '@magoosh/lib/dropdown';
import { FontAwesomeIcon } from '@magoosh/lib/icons';
import { bugsnagNotify } from 'utilities/bugsnag';

import { useAITutorContext } from '@test_prep/app/ai_tutor/context';
import { Interaction } from '@test_prep/app/ai_tutor/types';

import Activity from '../activity';
import ErrorMessage from '../error_message';
import GradientPill from '../gradient_pill';
import { CrossIcon, iconForSkill } from '../icons';

import style from './style.module.scss';

const ActivityPanel: React.FC<{}> = (props) => {
  const {
    activity,
    clearActivity,
    clearStack,
    handleNewInteractions,
    hideTutor,
    resetTutoringSession,
    tutoringSessionsStack
  } = useAITutorContext();

  const tutoringSession = tutoringSessionsStack.at(-1);

  const IconForSkill = iconForSkill(tutoringSession.domain, tutoringSession.initialSkill);

  const logError = (error: Error, info?: { componentStack: string }) => {
    bugsnagNotify(error);
  };

  return (
    <>
      <div className="visible-xs">
        <div className="align-items-center d-flex gap-s">
          <div className="align-items-center d-flex flex-1" style={{ gap: 8 }}>
            <div
              onClick={clearActivity}
              style={{
                color: '#929292',
                cursor: 'pointer',
                padding: '3px 5px'
              }}
            >
              <FontAwesomeIcon icon="comment" />
            </div>

            <FontAwesomeIcon icon="chevron-right" style={{ color: '#929292', fontSize: 11 }} />

            <GradientPill size="sm">
              <IconForSkill size={14} /> {activity.interactionPart.name}
            </GradientPill>

            <div className="align-items-end d-flex flex-1 justify-content-end">
              <div style={{ position: 'relative' }}>
                <Dropdown align="right">
                  <Dropdown.Trigger style={{ height: '100%' }}>
                    <a
                      className="align-items-end d-flex justify-self-end text-no-decoration text-hover-no-decoration"
                      style={{ color: '#9AA0A9', height: '100%', padding: '14px 7px 0 7px', }}
                    >
                      <FontAwesomeIcon icon="ellipsis-h" />
                    </a>
                  </Dropdown.Trigger>

                  <Dropdown.Content>
                    <ul className={style.dropdownItems}>
                      <li>
                        <a onClick={clearActivity}>
                          Back
                        </a>
                      </li>

                      <li>
                        <a onClick={clearStack}>
                          Home
                        </a>
                      </li>

                      <hr className="u-margin-A-n" />

                      <li>
                        <a onClick={resetTutoringSession}>
                          Reset
                        </a>
                      </li>
                    </ul>
                  </Dropdown.Content>
                </Dropdown>
              </div>

              <a
                className="align-items-center d-flex small text-bold text-no-decoration"
                onClick={hideTutor}
                style={{ color: '#9AA0A9', height: '100%', padding: 7 }}
              >
                <CrossIcon size={16} />
              </a>
            </div>


            {/*<GradientPill size="sm">
              <FontAwesomeIcon icon="asterisk" /> AI Tutor
            </GradientPill>

            <div className="d-flex flex-1 gap-m justify-content-end">
              <a
                className="small text-bold text-gray-light text-no-decoration"
                onClick={clearActivity}
              >
                Show Tutor Chat
              </a>

              <a
                className="small text-bold text-gray-light text-no-decoration"
                onClick={hideTutor}
              >
                Hide
              </a>
            </div>*/}
          </div>
        </div>
      </div>

      <div style={{ height: '100%', overflowY: 'scroll', overscrollBehavior: 'contain' }}>
        <div className="d-flex flex-column gap-m">
          {/* Min height makes the controls match those in tutoring panel */}
          <div className="align-items-center d-flex gap-m hidden-xs" style={{ minHeight: 30 }}>
            <div
              className="flex-1"
              style={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}
            >
              <Activity.Title activity={activity} />
            </div>

            <div className="align-items-center d-flex flex-none gap-m justify-content-end">
              <a
                className="small text-bold text-gray-light text-no-decoration"
                onClick={clearActivity}
              >
                Hide Activity
              </a>
            </div>
          </div>

          <ErrorBoundary
            fallback={<ErrorMessage message="Oops! Something went wrong with this activity." />}
            onError={logError}
          >
            <Activity
              activity={activity}
              addOrUpdateUserInteractions={handleNewInteractions}
            />
          </ErrorBoundary>
        </div>
      </div>
    </>
  );
};

export default ActivityPanel;
